import axios from 'helpers/axios';

export const getDeductibleCategories = async () => {
    // const { data } = await axios.post('/api/adminapi/getdeposits/', { select: 'pending' });
    const { data } = await axios.get('/api/adminapi/deductibles/categories/');

    return data;
};
